import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { store } from '@/store';
import { Permission, PermissionLevel } from '@/constants/client/permission';
import { getClientRoutes, getAgentRoutes, getAdminRoutes, getAuthRoutes } from '@/components/layout/routes';
import routes from '@/config/routes';
import { PrivateRoute } from './PrivateRoute';
import { canAccessCampaignsNav, hasPermission } from '@/helpers/permissionValidator';
import { UserType } from '@/store/enums';
import { ProfileLoading } from '@/components/auth/ProfileLoading';

const getRoutes = (userType: number, hasfetchedProfile: boolean): React.ReactElement => {
  const Logout = React.lazy(() => import('@/pages/public/logout'));

  const getRoutesByuserType = () => {
    switch (userType) {
      case UserType.client:
        return getClientRoutes();
      case UserType.agent:
        return getAgentRoutes();
      case UserType.admin:
        return getAdminRoutes();
      case UserType.unauthorized:
      default:
        return getAuthRoutes();
    }
  };

  const getAuthRedirect = (userType: number) => {
    if (hasfetchedProfile) {
      return <Redirect from={routes.root} to={getMainPage(userType)} />;
    } else {
      return <Route path="*" component={ProfileLoading} />;
    }
  };
  return (
    <Switch>
      <PrivateRoute path={routes.auth.logout} component={Logout} />
      {getRoutesByuserType()}
      {getAuthRedirect(userType)}
    </Switch>
  );
};

const getMainPage = (userType: number): string => {
  const state = store.getState();
  const hasActiveGigs: boolean = state.auth.user?.hasActiveGigs ?? false;

  switch (userType) {
    case UserType.agent:
      if (hasActiveGigs) {
        return routes.sp.scheduling.dashboard;
      }
      return routes.sp.onboarding.gigs;
    case UserType.client:
      if (hasPermission(Permission.SCHEDULE, PermissionLevel.ANY)) return routes.client.scheduling.index;
      if (canAccessCampaignsNav()) return routes.client.campaigns.index;
      return routes.client.dashboard.index;
    case UserType.admin:
      return routes.admin.gig.list;
    default:
    case UserType.unauthorized:
      return routes.auth.login;
  }
};

export { getRoutes, getMainPage };
